/* eslint-disable react/prop-types */
import React from 'react'

import { createAppKit } from '@reown/appkit/react'

import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { mainnet, arbitrum, solana, bitcoin } from '@reown/appkit/networks'

import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { SolanaAdapter } from '@reown/appkit-adapter-solana'
import { BitcoinAdapter } from '@reown/appkit-adapter-bitcoin'

// 0. Setup queryClient
const queryClient = new QueryClient()

// 1. Get projectId from https://cloud.reown.com
const projectId = process.env.REACT_APP_REOWN_PROJECT_ID

// 2. Create a metadata object - optional
const metadata = {
  name: 'Ospree',
  description: 'Ospree Verification',
  url: 'http://localhost:3000', // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/179229932'],
}

// 3. Set the networks
const networks = [mainnet, arbitrum, solana, bitcoin]

// 4. Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true,
})
const solanaAdapter = new SolanaAdapter({
  projectId,
  ssr: true,
})
const bitcoinAdapter = new BitcoinAdapter({
  projectId,
  ssr: true,
})

// 5. Create modal
createAppKit({
  adapters: [wagmiAdapter, solanaAdapter, bitcoinAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
    email: false, // default to true
    socials: [],
    emailShowWallets: false, // default to true
  },
  themeVariables: {
    '--w3m-font-family': 'OpenSans',
    '--w3m-accent': '#00CACD',
    '--w3m-color-mix': '#3c4351',
    '--w3m-border-radius-master': '3px',
  },
})

export default function AppKitProvider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}
